define('views/modules/calendar/activity/detail/activity-detail-content',[
    // Libs
    'underscore', 'backbone', 'mustache', 'utils',
    // Services
    'services/i18n',
    'services/user',
    'services/events/calendar-events',
    // Views
    'views/modules/calendar/activity/detail/blocks/details-form',
    'views/modules/calendar/activity/detail/blocks/advanced-details',
    'views/modules/calendar/activity/detail/blocks/calories-burn',
    'views/parts/form/button',
    'views/modules/calendar/calendar-item-panel-content',
    'views/modules/calendar/calendar-item-daily-stats',
    'views/modules/calendar/favorite/favorite-modal',
    'views/parts/alert/alert-list',
    'views/modules/calendar/activity/member/detail/blocks/about-activity',
    // collections
    'collections/calendar/text-session/activity-types',
    // Templates Blocks
    'text!templates/modules/calendar/activity/detail/activity-detail-content.html'
], function(
    // Libs
    _, Backbone, Mustache, U,
    // Services
    i18n,
    User,
    CalendarEvents,
    // Views
    VBlockActivityDetailsForm,
    VAdvancedDetails,
    VCaloriesBurn,
    VButton,
    VCalendarItemPanelContent,
    VCalendarItemDailyStats,
    VFavoriteModal,
    VAlertList,
    VAboutActivity,
    // collections
    CActivityTypes,
    // Template
    TActivityDetails
) {

    var VActivityDetails = VCalendarItemPanelContent.extend({
        contentTemplate: TActivityDetails,
        fields: VCalendarItemPanelContent.prototype.fields.concat(
            ['sup_name', 'sup_description', 'activity', 'duration', 'effort', 'calories', 'name', 'distance']
        ),

        regions: _.extend({}, VCalendarItemPanelContent.prototype.regions, {
            details: ".activity-details-form",
            stats: ".item-stats",
            showMore: ".show-more",
            advancedDetails: ".advanced-details",
            calories: ".calories",
            secondaryDetails: '.secondary-details',
            moreDetailsAlert: '.more-details-alert',
            alert: '.alert-list',
            aboutActivity: ".about-activity",
        }),

        initialize: function(opt) {
            VActivityDetails.__super__.initialize.call(this, opt);

            var model = this.model,
                collection = this.collection = new CActivityTypes(),
                view = _.extend(this.view, {
                    details: new VBlockActivityDetailsForm({ model: model, group: this.group }),
                    showMore: new VButton({
                        label: i18n.t("calendar:Additional Details"),
                        callback: this.onShowMoreDetails,
                        icon: "sl-icon-arrow-down",
                        context: this,
                        block: true
                    }),
                    advancedDetails: new VAdvancedDetails({
                        model: model,
                        masterCarbon: this.masterCarbon,
                        profile: this.profile,
                        collection: collection
                    }),
                    stats: new VCalendarItemDailyStats({
                        model: this.model
                    }),
                    alert: new VAlertList({ dismissable: false }),
                    aboutActivity: new VAboutActivity({
                        model: model,
                        activities: this.collection
                    }),
                });

            if (this.role === 'supervisor') {
                view.menu.addMoreActions([{ icon: 'sl-icon-star', caption: 'Add current activity to my favorites', callback: this.onAddToFavoriteAction, context: this }]);
            }

            this.listenTo(model, 'apply:model', this.applyModel);
            this.listenTo(this.view.aboutActivity, 'edit:activity', this.onEditActivity);
        },

        render: function() {
            VActivityDetails.__super__.render.call(this);

            var model = this.model,
                view = this.view,
                zone = this.zone;

            this.assign(view.details, zone.$details)
                .assign(view.advancedDetails, zone.$advancedDetails, { defer: true })
                .assign(view.showMore, zone.$showMore)
                .assign(view.stats, zone.$stats)
                .assign(view.alert, zone.$alert);
            // .assign(view.calories, zone.$calories);

            // if (model.hasAdvancedDetails()) {
            //     this.changeShowMoreText();
            // }

            if (this.role === "client") {
                this.changeShowMoreText();
                this.zone.$secondaryDetails.show();
            }

            if (model.getDescription() || model.getName()) {
                this.assign(view.aboutActivity, this.zone.$aboutActivity);
                this.zone.$details.hide();
            }

            this.view.alert.reset();

            if (this.userCanSeeAlert()) {
                this.view.alert.addInfo(i18n.t('calendar:this-item-is-hidden'));
            }

            this.collection.fetch();

            return this;
        },

        userCanSeeAlert: function() {
            if (! User.getSupervisorGroup().daysBeforeCalendarItemsAreHidden || this.model.isNew() || this.model.get('isVisible')) {
                return false;
            }

            return this.model.isAfterDays(User.getSupervisorGroup().daysBeforeCalendarItemsAreHidden);
        },

        getContentContext: function() {
            return {
                newModel: this.model.isNew(),
            };
        },

        changeShowMoreText: function() {
            var button = this.zone.$showMore,
                buttonView = this.view.showMore,
                moreDetailsAlert = this.zone.$moreDetailsAlert,
                icon = buttonView.zone.$icon;

            icon.toggleClass('flipped');
            buttonView.setLabel(i18n.t(buttonView.options.label));

            if (icon.hasClass('flipped')) {
                buttonView.setLabel(i18n.t('Show less details'));
            }

            moreDetailsAlert.toggleClass('hidden');
        },

        /////////////
        // actions //
        /////////////

        onAddToFavoriteAction: function(e, actionModel) {
            var view = this.view.favorite;

            if (!view) {
                view = this.view.favorite = new VFavoriteModal({
                    type: 'calendar-activity',
                    item: this.model
                });
                this.listenTo(view, 'form:success', this.onFavoriteSuccess);
            }

            view.resetModel().render();
        },

        /////////////
        // events //
        /////////////

        onShowMoreDetails: function() {
            this.zone.$secondaryDetails.slideToggle({
                done: this.changeShowMoreText.bind(this)
            });
        },

        onFavoriteSuccess: function(model) {
            this.trigger('favorite:success', model);
        },

        onEditActivity: function () {
            this.zone.$details.show();
            this.zone.$aboutActivity.hide();
        }

    });

    return VActivityDetails;
});

